import { h } from 'preact';
import * as BaseComp from 'components/bolt/home/home.js';
import Store from 'store/store';

import Button from 'components/bolt/button/button';
import Socials from 'components/bolt/socials/socials';
import MovieDetails from 'components/bolt/movieDetails/movieDetails';

import { scale } from 'utils/math';
import { cssString } from 'utils/cssString';
import { joinClasses, accessNested } from 'utils/utils';

import s from 'components/bolt/home/home.sss';

export default class Home extends BaseComp.default {

	renderHomeSection(bgRender) {
		let props = this.props;
		// TODO: alow the homepage to have a different ID (loop through pages and check for page === home + base & everything)
		let boltHome = accessNested(props, 'store.appData.pages.boltHome');
		if (!boltHome) {
			return;
		}
		let store = props.store;
		let client = store.client;
		let appData = store.appData;
		let copy = appData.copy;
		let fontStyles = accessNested(appData, 'styling.fontVariables') || {};
		let homeData = accessNested(appData, 'pages.boltHome.data') || {};

		const activeSection = accessNested(store, 'header.activeSection');
		const homeActivePercentage = accessNested(store, 'homeActivePercentage', 1);
		const homeScrolledALittleBit = homeActivePercentage <= .8;
		const homeActive = !activeSection || activeSection === 'boltHome' || homeActivePercentage > .3;

		const stickyFooter = (accessNested(appData, 'footer.defaultFooter.position') || 'fixed') === 'fixed';

		let showtimesShowing = accessNested(store, 'showtimes.show');
		const homeEntShowing = accessNested(store, 'homeEnt.show');

		let sidePanelShowing = showtimesShowing || accessNested(store, 'homeEnt.show');
		let animateSidePanel = accessNested(store, 'showtimes.animate') || accessNested(store, 'homeEnt.animate');

		const externalBannerOpen = accessNested(store, 'externalCookieBanner.bannerOpen');
		const cookieHeight = (externalBannerOpen ? accessNested(store, 'externalCookieBanner.height') : accessNested(store, 'cookies.height')) || 0;
		const cookieBannerOpen = externalBannerOpen || accessNested(store, 'cookies.cookieBannerOpen');
		const isMobile = !client.isDesktopSize;

		const shouldShowSocials = (isMobile && homeData.socialIconsMobile) || (!isMobile && !stickyFooter);
		const hasMiniGallery = accessNested(appData, 'options.paramountFeatures.toutCarousel.contentCarousel', false);
		const scrollFade = scale(homeActivePercentage, .8, .3, 0, 1, true);

		const blackColor = accessNested(this.props, 'appData.styling.variables.black', '');
		const hideShadow = accessNested(this.props, 'appData.styling.variables.homeScrollArrow', '') === blackColor;

		const scrollable = this.getVisibleSections().length > 0;

		// Until we update preact, if we use custom properties we have to stringify "style"
		const containerStyle = {
			...this.determineHomeHeight(),
			'--scroll-fade': scrollFade,
		};

		return (
			<div
				class={joinClasses({
					s, container: true,
					sidePanelShowing,
					homeScrolledALittleBit,
					homeInactive: !homeActive,
					stickyFooter,
					animateSidePanel
				})}
				style={cssString(containerStyle)}
				data-section="boltHome"
				key="home"
				onTouchStart={() => Store.emit('PLAY_BACKGROUND_VIDEO')}
				onClick={() => Store.emit('PLAY_BACKGROUND_VIDEO')}
			>
				{bgRender}
				{scrollable && <div class={s.scrollFade} />}
				<MovieDetails
					type="home"
					visible={isMobile || (homeActivePercentage >= 0.8 || !scrollable) && !showtimesShowing && !homeEntShowing}
					hide={scrollable && homeActivePercentage < 0.8 && !showtimesShowing && !homeEntShowing}
					tt={homeData.tt}
					buttons={[homeData.button1, homeData.button2, homeData.button3]}
					copy={copy}
					appData={appData}
					cookieHeight={cookieHeight}
					cookieBannerOpen={cookieBannerOpen}
					buttonLayout={homeData.btnLayout}
					client={this.props.client}
				/>
				{scrollable && this.renderScrollArrow(copy, stickyFooter, isMobile, externalBannerOpen, hasMiniGallery, hideShadow)}
				<Button
					class={joinClasses(s.filmDetails, fontStyles.showtimesOnesheetCTA)}
					trigger={this.openSynopsis}
					key="synopsis"
				>
					{copy.baseCopy.$FILM_DETAILS}
				</Button>
				{this.renderExtraStuff()}
				{shouldShowSocials && (
					<Socials
						class={joinClasses(s.socials, stickyFooter && s.socialsStickyFooter, hasMiniGallery && s.hasMiniGallery, hideShadow && s.hideShadow)}
						socials={accessNested(appData, 'header.powsterHeader.follow')}
						key="socials"
					/>
				)}
			</div>
		);
	}
}
